import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import { tntGreen, tntFadedGreen, tntFadedRed, tntRed } from '../../theme/tntColors';
import { grey200, darkBlack } from 'material-ui/styles/colors';
import saddestSmiley from '../../img/smileys/saddest.svg';
import happiestSmiley from '../../img/smileys/happiest.svg';
import number1 from '../../img/numbers/number-1-normal.svg';
import number5 from '../../img/numbers/number-5-normal.svg';
import star1 from '../../img/stars/1.png';
import star5 from '../../img/stars/5.png';
import {
  QUESTION_TYPE_AGREE,
  QUESTION_TYPE_FIVESTARS,
} from '../../constants';
import agree from '../../img/agree/agree.png';
import dontAgree from '../../img/agree/dont-agree.png';

const styles = {
  wrapper: {
    padding: 15
  },
};

class Gauge extends Component {
  render() {

    const {
      useNumbers,
      question,
    } = this.props.widgetConfig || {};

    const {
      type,
    } = question || {};

    let positiveIcon = useNumbers ? number5 : happiestSmiley;
    let negativeIcon = useNumbers ? number1 : saddestSmiley;

    if (type === QUESTION_TYPE_FIVESTARS) {
      positiveIcon = star5;
      negativeIcon = star1;
    }

    if (type === QUESTION_TYPE_AGREE) {
      positiveIcon = agree;
      negativeIcon = dontAgree;
    }

    let chartHeight = this.props.height - (styles.wrapper.padding * 2);
    let chartWidth = this.props.width - (styles.wrapper.padding * 2);

    const chartConfig = {
      chart: {
        type: 'solidgauge',
        // Highcharts throws an error if the container is too small
        height: chartHeight >= 50 ? chartHeight : 50,
        width: chartWidth >= 50 ? chartWidth : 50,
      },
      title: null,
      tooltip: {
        enabled: false,
      },
      pane: {
        center: ['50%', '90%'],
        size: '160%',
        startAngle: -60,
        endAngle: 60,
        background: {
          backgroundColor: grey200,
          borderColor: grey200,
          innerRadius: '60%',
          outerRadius: '100%',
          shape: 'arc',
        }
      },
      yAxis: {
        stops: [
          [0.50, tntRed],
          [0.67, tntFadedRed],
          [0.84, tntFadedGreen],
          [1, tntGreen],
        ],
        minorTickInterval: null,
        tickAmount: 0,
        tickWidth: 0,
        lineWidth: 0,
        labels: {
          y: 8,
          distance: -18,
          useHTML: true,
          formatter: function () {
            const imageSize = type === QUESTION_TYPE_AGREE ? 50 : 35;
            const imageHeight = type === QUESTION_TYPE_AGREE ? 28 : imageSize;
            const image = this.isFirst ? negativeIcon : positiveIcon;
            return `<img 
              width="${imageSize}px"
              height="${imageHeight}px"
              src="${image}" />`;
          },
        },
        min: 0,
        max: 10,
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            y: 5,
            borderWidth: 0,
            useHTML: true,
            format:
              '<div style="text-align:center">' +
              '<span style="font-size:25px;color:' + darkBlack + '">' +
              '{y:.1f}' +
              '</span>' +
              '<br/>' +
              '<span style="font-size:12px;color:silver">/10</span>' +
              '</div>'
          },
        },
      },
      series: [{
        data: [this.props.answersReport.score],
      }],
    };

    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{ id: this.props.uniqueId }}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  Gauge,
  graphql`
    fragment Gauge_answersReport on AnswersReport {
      score
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/Gauge/Gauge.js